"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExplorerFileType = void 0;
var ExplorerFileType;
(function (ExplorerFileType) {
    ExplorerFileType[ExplorerFileType["Default"] = 0] = "Default";
    ExplorerFileType[ExplorerFileType["Form"] = 1] = "Form";
    ExplorerFileType[ExplorerFileType["Flow"] = 2] = "Flow";
    ExplorerFileType[ExplorerFileType["FormCode"] = 3] = "FormCode";
    ExplorerFileType[ExplorerFileType["FlowCode"] = 4] = "FlowCode";
    ExplorerFileType[ExplorerFileType["Class"] = 5] = "Class";
    ExplorerFileType[ExplorerFileType["Controller"] = 6] = "Controller";
    ExplorerFileType[ExplorerFileType["Entity"] = 7] = "Entity";
    ExplorerFileType[ExplorerFileType["Api"] = 8] = "Api";
    ExplorerFileType[ExplorerFileType["Designer"] = 9] = "Designer";
    ExplorerFileType[ExplorerFileType["Html"] = 10] = "Html";
    ExplorerFileType[ExplorerFileType["Css"] = 11] = "Css";
    ExplorerFileType[ExplorerFileType["Ts"] = 12] = "Ts";
    ExplorerFileType[ExplorerFileType["Tsx"] = 13] = "Tsx";
    ExplorerFileType[ExplorerFileType["TsDesigner"] = 14] = "TsDesigner";
    ExplorerFileType[ExplorerFileType["Config"] = 15] = "Config";
    ExplorerFileType[ExplorerFileType["Assembly"] = 16] = "Assembly";
    ExplorerFileType[ExplorerFileType["DepsJson"] = 17] = "DepsJson";
    ExplorerFileType[ExplorerFileType["Scss"] = 18] = "Scss";
    ExplorerFileType[ExplorerFileType["Js"] = 19] = "Js";
    ExplorerFileType[ExplorerFileType["Jsx"] = 20] = "Jsx";
    ExplorerFileType[ExplorerFileType["SuitForm"] = 21] = "SuitForm";
    ExplorerFileType[ExplorerFileType["EntityMapping"] = 22] = "EntityMapping";
    ExplorerFileType[ExplorerFileType["EntityMigration"] = 23] = "EntityMigration";
    ExplorerFileType[ExplorerFileType["SqlQuery"] = 24] = "SqlQuery";
    ExplorerFileType[ExplorerFileType["WebServiceQuery"] = 25] = "WebServiceQuery";
    ExplorerFileType[ExplorerFileType["RestQuery"] = 26] = "RestQuery";
    ExplorerFileType[ExplorerFileType["ErpQuery"] = 27] = "ErpQuery";
    ExplorerFileType[ExplorerFileType["Scheduler"] = 28] = "Scheduler";
    ExplorerFileType[ExplorerFileType["SapQuery"] = 30] = "SapQuery";
    ExplorerFileType[ExplorerFileType["Image"] = 31] = "Image";
    ExplorerFileType[ExplorerFileType["Txt"] = 32] = "Txt";
    ExplorerFileType[ExplorerFileType["Migration"] = 33] = "Migration";
    ExplorerFileType[ExplorerFileType["Report"] = 34] = "Report";
    ExplorerFileType[ExplorerFileType["GptQuery"] = 26] = "GptQuery";
})(ExplorerFileType || (exports.ExplorerFileType = ExplorerFileType = {}));
exports.default = ExplorerFileType;
//# sourceMappingURL=ExplorerFileType.js.map